export const COMPANY_LEGAL_NAME = 'Leland Little Auctions'
